module.exports = __webpack_public_path__ + "static/media/travel-locations.f3211a35.png";